import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerPWA } from './lib/pwa';
import { applyTheme, getTheme } from './lib/theme';

applyTheme(getTheme());

registerPWA();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
